<template>
  <section class="local-lm-dashboard-menu">
    <b-menu-list>
      <b-menu>
        <b-menu-item
          v-if="showEAD"
          icon="home"
          :label="$t('DashboardMenu.labelOrders')"
          tag="router-link"
          :to="{ name: 'Orders' }"
        />
        <b-menu-item
          v-if="show"
          icon="alert"
          :label="$t('DashboardMenu.labelIncidences')"
          tag="router-link"
          :to="{ name: 'Incidences' }"
        />
        <b-menu-item
          v-if="showEDF"
          icon="truck-fast"
          :label="$t('DashboardMenu.labelOrdersEDF')"
          tag="router-link"
          :to="{ name: 'Edf' }"
        />
        <b-menu-item
          v-if="showEDD"
          icon="warehouse"
          :label="$t('DashboardMenu.labelOrdersEDD')"
          tag="router-link"
          :to="{ name: 'Edd' }"
        />
        <b-menu-item
          icon="flag"
          :label="$t('DashboardMenu.labelCompletedOrders')"
          tag="router-link"
          :to="{ name: 'Completed' }"
        />
        <b-menu-item
          v-if="showAdmin"
          icon="settings"
          :label="$t('DashboardMenu.labelAdmin')"
          tag="router-link"
          :to="{ name: 'Admin' }"
        />
      </b-menu>
    </b-menu-list>
  </section>
</template>

<script>
import { services } from '@/services'

export default {
  name: 'DashboardMenu',
  data () {
    return {
      show: false,
      showAdmin: false,
      showEAD: false,
      showEDD: false,
      showEDF: false
    }
  },
  async mounted () {
    const user = this.$store.getters['user/status'].info
    const {
      authorities,
      eadVisibility,
      eddVisibility,
      edfVisibility
    } = user

    const rules = services.userService('', authorities)
    const showAdminOption = rules.showAdmin()

    if (showAdminOption) this.showAdmin = showAdminOption
    if (eadVisibility) this.showEAD = eadVisibility
    if (eddVisibility) this.showEDD = eddVisibility
    if (edfVisibility) this.showEDF = edfVisibility
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/DashboardMenu.vue